/// <reference path="../../../../../rcwebmodels/reeferhistory.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
import * as React from 'react';
//import Bing from '../../actions/ReeferMapCallout.js';
//import * as ReeferMapjs from '../../actions/ReeferMapCallout.js';
//var Bing = ReeferMapjs.default;
import MapCallout from '../../actions/MapCallout';
import { AgGridReact } from 'ag-grid-react';

import Formatters from '../../actions/Formatters';
import ReeferFormatters from '../../actions/ReeferFormatter';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';
import $ from 'jquery';
import DateFormat from 'dateformat';
import moment from 'moment';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import { GridToolBarExcel } from '../sharedcomponents/GridToolBarExcel';
import lodashfilter from 'lodash/filter';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
//import '../../../node_modules/react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.min.css';
import * as Exceljs from '../../actions/ExportToExcel.js';
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');

export interface ReeferGridState {
    rowData: server.UnitHistoryUI[],
    columnDefs: any[],
    Filters: ReeferHistoryFilter,
    mapState: string,
    overlayLoadingTemplate: any,
    pageSize: any,
    gridApiParams: any,
    reeferFormatter: server.ReeferFormatter;//WI-21810:QA_IE_Event description is displayed as 'NA' in reefer map screen
    PreferenceDTTM: any;
    modelTitleReport: string;
    popUpHtmlReport: any;
    PTReport: string;
    ReportReeferId: string;
    selectedDataItems: any[];
    IsLocationEstimated: boolean;
    DashboardPreferenceId: any;
    DashboardWidgetsSearch: any[];
    IsReadOnly: any;
    RevisionNum: any;
}

var self;
var functionId;
var reeferCurrentStatus;
var selectedReefer = [];
var columnDefs2: any[];
var columnDefs: any[];
var reeferAssetSensors: any[];

export class ReeferMapGrid extends React.Component<any, ReeferGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.initHistoryFilters();//new ReeferHistoryFilter();
        functionId = 42; // functionId for ReeferHistory Grid
        //var columnDefs = this.createColumnDefs();
       
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetCustomerDeviceTypeSensor');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.renderCustomerDeviceTypeSensorColumns(data);
            });
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        reeferCurrentStatus = [];
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        if (this.props.historyData != undefined && this.props.historyData != null) {
            reeferCurrentStatus.push(this.props.historyData[0]);
            this.state = {
                rowData: this.props.historyData[0], columnDefs: [], Filters: filterSet, mapState: "CurrentLocation", overlayLoadingTemplate: overlayTemplate
                , pageSize: 25
                , gridApiParams: []
                , reeferFormatter: null//WI-21810:QA_IE_Event description is displayed as 'NA' in reefer map screen
                , PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm)
                , modelTitleReport: '', popUpHtmlReport: '', PTReport: '', ReportReeferId: ''
                , selectedDataItems: []
                , IsLocationEstimated: false
                , DashboardWidgetsSearch: []
                , IsReadOnly: false
                , DashboardPreferenceId: 0
                , RevisionNum: 0
            };
        }
        else
            this.state = {
                rowData: [], columnDefs: [], Filters: filterSet, mapState: "CurrentLocation", overlayLoadingTemplate: overlayTemplate
                , pageSize: 25
                , gridApiParams: []
                , reeferFormatter: null//WI-21810:QA_IE_Event description is displayed as 'NA' in reefer map screen
                , PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm)
                , modelTitleReport: '', popUpHtmlReport: '', PTReport: '', ReportReeferId: ''
                , selectedDataItems: []
                , IsLocationEstimated: false
                , DashboardWidgetsSearch: []
                , IsReadOnly: false
                , DashboardPreferenceId: 0
                , RevisionNum: 0
            };
        this.GetDefaultGridPreferenceColumns();
        //this.PopulateReeferenceData();//WI-21810:QA_IE_Event description is displayed as 'NA' in reefer map screen
        this.populateDefaultDates();
        self = this;
        columnDefs2 = this.createColumnDefs();
    }
       GetDefaultGridPreferenceColumns() {
       var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        var GridPreferenceColumns: any;
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
               // RCNG 5198 - OMP - UI:The selected grid columns are not displayed for Export excel and send Email
                if (data != null &&  data != undefined && data.DashboardWidgetsSearch != null && data.DashboardWidgetsSearch.length > 0) {
                    GridPreferenceColumns = data.DashboardWidgetsSearch.filter(x => x.WidgetName == 'Reefer History')
                }
                if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
                {
                    var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    if(defaultPreferenceName.length>0)                    
                        this.setState({ DashboardPreferenceId: defaultPreferenceName[0].DashboardPreferenceId, IsReadOnly: defaultPreferenceName[0].IsReadOnly, RevisionNum: defaultPreferenceName[0].RevisionNum, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    else {
                        var dashboardLayouts: any = data.DashboardLayouts;
                        this.setState({ DashboardPreferenceId: dashboardLayouts[0].DashboardPreferenceId, IsReadOnly: dashboardLayouts[0].IsReadOnly, RevisionNum: dashboardLayouts[0].RevisionNum, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    }
                }  
               // RCNG 5198 - OMP - UI:The selected grid columns are not displayed for Export excel and send Email

                setTimeout(() => {
                    GridColumnPreferences.HistoryGridPreferenceColumns(functionId, this.state.gridApiParams, GridPreferenceColumns, "ReeferMapGrid");

                }, 2000);

            }); 

    }
    // RCNG 5198 - OMP - UI:The selected grid columns are not displayed for Export excel and send Email
    static GetReeferMapGridPreferenceColumns() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        var GridPreferenceColumns: any;
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
                if (data.DashboardLayouts != null && data.DashboardLayouts.length > 0) {
                    var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
                    if (defaultPreferenceName.length > 0)
                        self.setState({ DashboardPreferenceId: defaultPreferenceName[0].DashboardPreferenceId, IsReadOnly: defaultPreferenceName[0].IsReadOnly, RevisionNum: defaultPreferenceName[0].RevisionNum, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    else {
                        var dashboardLayouts: any = data.DashboardLayouts;
                        self.setState({ DashboardPreferenceId: dashboardLayouts[0].DashboardPreferenceId, IsReadOnly: dashboardLayouts[0].IsReadOnly, RevisionNum: dashboardLayouts[0].RevisionNum, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    }
                }
               
            });

    }
    initHistoryFilters() {
        var reeferHistoryFilter = new ReeferHistoryFilter();
        reeferHistoryFilter.Units = '';
        reeferHistoryFilter.FromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        reeferHistoryFilter.ToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');

        return reeferHistoryFilter;
    }

    renderCustomerDeviceTypeSensorColumns(customerDeviceTypeSensor: any) {
        columnDefs = this.createColumnDefs();
        var newColumns = columnDefs;
        //columnDefs2 = columnDefs;
        var generatedColumns = [];

        if (customerDeviceTypeSensor != null && customerDeviceTypeSensor != undefined)
            reeferAssetSensors = customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'R');

        if (reeferAssetSensors != null && reeferAssetSensors != undefined && reeferAssetSensors.length > 0) {
            $.each(reeferAssetSensors, function (i, val) {
                var customerDeviceTypeSensorObject: any;
                if (val.SensorTypeCd.trim() == "T")
                    customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130 };
                else
                    customerDeviceTypeSensorObject = { headerName: '', field: '', refData: val.SensorSetDsc + "," + val.SensorResetDsc, headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, valueGetter: Formatters.stringTypeSortingForDigitalSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130 };

                //var fieldName = val.FieldValue;
                var columnHeaderName = val.ColumnNm;
                var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                customerDeviceTypeSensorObject.headerName = columnHeaderName;
                customerDeviceTypeSensorObject.field = columnFieldName;
                generatedColumns.push(customerDeviceTypeSensorObject);
            });

            var newSensorColumnDefination = {
                headerName: "Device Sensor(s)",
                children: generatedColumns
            };
            if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                newColumns.push(newSensorColumnDefination);
            this.setState({ columnDefs: newColumns });

            if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                columnDefs2.push(newSensorColumnDefination);// = newColumns;
        }
        else {
            this.setState({ columnDefs: columnDefs });
        }
    }


    PopulateReeferenceData() {
        if (this.state.reeferFormatter == null || this.state.reeferFormatter == undefined) {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferFormatter>)
                .then(data => {
                    this.setState({
                        reeferFormatter: data
                    });
                });
        }
    }

    populateDefaultDates() {                
        var toDTTM = this.state.PreferenceDTTM;       
        var modifiedDttm = new Date(toDTTM);
        modifiedDttm.setDate(modifiedDttm.getDate() - 1);
        var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
        var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
        var toDate = moment(new Date(toDTTM)).endOf('day').toString();
        this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
    }

    onGridReady(params: any) {
        //this.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
        //this.gridApi.sizeColumnsToFit();
        var gridPreferencesData: any = self.state.DashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 5);
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        //GridPreferenceControl.HistoryGridPreferenceColumns(functionId, params.api);
        setTimeout(() => {            
            GridColumnPreferences.HistoryGridPreferenceColumns(functionId, params.api, gridPreferencesData, "ReeferMapGrid");
        }, 3000); 
    }

    refreshGrid = () => {
        if (this.state.mapState == "ReeferTrace") {
            this.populateSelectedReefersDates();
            this.bindReeferHistoryData();            
        }
        else {
            this.populateDefaultDates();
            this.bindReeferCurrentData();            
        }
    };

    onGridSelectionChanged(params: any) {
        self.setState({ IsLocationEstimated: false });
        var selectedRows = params.api.getSelectedRows(); 
        if (selectedRows != null && selectedRows != undefined) {            
            if (self.state.mapState == "CurrentLocation") {
                setTimeout(() => { self.showSelectedPushin(selectedRows); }, 500); // WI 26554 added timeout to display callout by default
            }
            else
                self.BindMapPushPin(selectedRows);

            self.setState({
                selectedDataItems: selectedRows
            });
        }
    }

    showSelectedPushin(selectedRows: any) {
        selectedRows.forEach(function (selectedRow, index) {
            MapCallout.DisplaySelectedPushpin(selectedRow, self.props.reeferFormatter);
            selectedReefer = [];
            selectedReefer.push(selectedRow);
        });
    }

    BindMapPushPin(selectedRows: any) {        
        var selectedRowsWithCoords = lodashfilter(selectedRows, function (item) {
            return item.GPSCoords != null && item.GPSCoords != undefined && item.GPSCoords.toString() != "";
        });
        if (selectedRowsWithCoords != null && selectedRowsWithCoords.length > 0)
            MapCallout.DisplaySelectedPushpin(selectedRowsWithCoords[0], self.props.reeferFormatter);
        else {
            if (self.state.rowData != null && self.state.rowData != undefined && self.state.rowData.length > 0) {
                var selectedRowIndex = self.state.rowData.findIndex(row => row.ParentEventID === selectedRows[0].ParentEventID);
                if (selectedRowIndex != -1) {
                    if (selectedRowIndex == self.state.rowData.length - 1) {
                        MapCallout.DisplaySelectedPushpin(selectedRows[0], self.props.reeferFormatter);
                    }
                    else {
                        for (var rowIndex = selectedRowIndex + 1; rowIndex < self.state.rowData.length; rowIndex++) {
                            var rowCurrentData = self.state.rowData[rowIndex];
                            if (rowCurrentData.GPSCoords != null && rowCurrentData.GPSCoords != undefined && rowCurrentData.GPSCoords.toString() != "") {
                                self.setState({ IsLocationEstimated: true });
                                selectedRows[0].GPSLatitude = rowCurrentData.GPSLatitude;
                                selectedRows[0].GPSLongitude = rowCurrentData.GPSLongitude;
                                MapCallout.DisplaySelectedPushpin(selectedRows[0], self.props.reeferFormatter);
                                break;
                            }
                            else if (rowIndex == self.state.rowData.length - 1) {
                                MapCallout.DisplaySelectedPushpin(selectedRows[0], self.props.reeferFormatter);
                            }
                        }
                    }
                }
            }
        }
    }

    static popUpGetPTIReport(selectedPin) {       
            if (selectedPin.ReeferID != null) {
                $('#globalLoader').show();
                var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTRReport?containerID=' + selectedPin.ReeferID;
                var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json())
                    .then(result => {   
                        self.setState({ PTReport: result, ReportReeferId: selectedPin.ReeferID}, () => { $('#globalLoader').hide(); });
                        if (self.state.PTReport == null || self.state.PTReport == '')                  
                        PopupWindow.showErrorMessage("Alert", "No pre-trip reports have been collected for this reefer. Execute the ‘Get Pre-Trip Results’ command to collect the latest available report.");
                        else {
                            self.setState({ popUpHtmlReport: <div dangerouslySetInnerHTML={{ __html: self.state.PTReport }} /> });
                             $('#btnTrigger').click();
                        }
                    });
            }

    }


    FromDateChange(date) {
        var filters = self.state.Filters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({
            Filters: filters
        });
    }

    ToDateChange(date) {
        var filters = self.state.Filters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({
            Filters: filters
        });
    }

    onPaginationPageLoaded(params: any) {
        var currentpage = params.api.paginationGetCurrentPage();
        var pagesize = params.api.paginationGetPageSize();
        var rowindex = pagesize * currentpage - 1;

        var rowNode = params.api.getRowNode(rowindex + 1);
        // do something with the row, eg select it
        if (rowNode != undefined && rowNode != null)
            rowNode.setSelected(true);
    }

    populateSelectedReefersDates() {
        if (selectedReefer[0].EventDTTM != null && selectedReefer[0].EventDTTM != "") {
            //var toDTTM = DateFormat(new Date(selectedReefer[0].EventDTTM), 'mm/dd/yyyy');
            var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
            var currenttoDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
            var toDTTM = Formatters.DateTimeFormatter(selectedReefer[0].EventDTTM);
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(currenttoDTTM)).endOf('day').toString();
            this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        }
        else {
            var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
            var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        }

        this.state.Filters.Units = selectedReefer[0].UnitMasterID;
        //var CurrentReefers = "";
        //var CurrentReefersList = [];
        //reeferCurrentStatus[0].forEach(function (item, index) {
        //    CurrentReefersList.push(item.UnitMasterID);
        //});

        //CurrentReefers = CurrentReefersList.join(",");
        //this.state.Filters.Units = CurrentReefers;
    }

    bindReeferHistoryData() {
        self.state.gridApiParams.showLoadingOverlay();
        MapCallout.ClearMapPushpins();
        self.setState({ IsLocationEstimated: false });
        var fromDate = moment(new Date(this.state.Filters.FromDate)).startOf('day').toString();
        var toDate = moment(new Date(this.state.Filters.ToDate)).endOf('day').toString();
        this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.UnitHistoryUI[]>)
            .then(data => {
                if (data.length > 0) {
                    MapCallout.BindTraceMapPushpins(data, "trace", self.props.reeferFormatter);   
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                }

                this.setState({
                    rowData: data
                });
                self.state.gridApiParams.paginationGoToFirstPage();              
                self.state.gridApiParams.hideOverlay();               
            });
    }

    bindReeferCurrentData() {
        $('#globalLoader').show();
        var CurrentReefers = "";
        var CurrentReefersList = [];
        reeferCurrentStatus[0].forEach(function (item, index) {
            CurrentReefersList.push(item.ReeferID);
        });

        CurrentReefers = CurrentReefersList.join(",");
        var reeferSearchFilters: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedReefer: CurrentReefers, SelectedGeofence: '', SelectedInterval: '', SelectedGeofenceInside: '', SelectedVesselCode: '', StatusFilters: [], AllReefers: '',
            CustomAttributeFilters: null, SelectedAssetTypes: '', SelectedAssetStates: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedVoyage: '', SelectedCall: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: [] //WI-26881
            };
        var filterParams = JSON.stringify(reeferSearchFilters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(response => response.json() as Promise<ReeferMasterStatus[]>)
            .then(data => {
                self.setState({
                    rowData: data
                });

                self.state.gridApiParams.paginationGoToFirstPage();
                if (data.length > 0) {
                    MapCallout.BindTraceMapPushpins(data, "current", self.props.reeferFormatter);
                    MapCallout.DisplaySelectedPushpin(data[0], self.props.reeferFormatter);
                }
                $('#globalLoader').hide();
            });
    }

    ApplyReeferHistorySearch() {
        var message = this.ValidateHistoryDates();
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }

        self.state.gridApiParams.showLoadingOverlay();        
        MapCallout.ClearMapPushpins();
        self.setState({ IsLocationEstimated: false });
        var fromDate = moment(new Date(this.state.Filters.FromDate)).toString();
        var toDate = moment(new Date(this.state.Filters.ToDate)).toString();
        this.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.UnitHistoryUI[]>)
            .then(data => {
                if (data.length > 0) {
                    MapCallout.BindTraceMapPushpins(data, "trace", self.props.reeferFormatter);                    
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                    self.state.gridApiParams.paginationGoToFirstPage();                   
                    self.state.gridApiParams.hideOverlay();
                }
                this.setState({
                    rowData: data
                });
            });
    }

    ValidateHistoryDates() {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
        //var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = this.state.Filters.FromDate;
        var toDttm = this.state.Filters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    createColumnDefs() {
        return [
            {
                headerName: 'State Indicators History',
                children: [
                    { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
                    { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.StatusIndicatorWithDescriptionForALM, refData: self.props.reeferFormatter.AlarmMasterList },
                    { headerName: "RUN", field: "RunState", width: 65, valueGetter: (params) => { return ReeferFormatters.RunstateSorting(params); }, cellRenderer: ReeferCellRenderer.RunStateFormatter },
                    { headerName: "PWR", field: "DevicePowerSourceCd", width: 65, valueGetter: (params) => { return Formatters.PwrSorting(params); }, cellRenderer: ReeferCellRenderer.PwrStateFormatter },
                    { headerName: "BATT", field: "ReeferBatteryPct", width: 65, valueGetter: (params) => { return Formatters.reeferBatteryPctSorting(params); }, cellRenderer: ReeferCellRenderer.BatteryPctFormatter },
                    { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
                    { headerName: "VVC Dep", field: "DepartingVVC", valueGetter: (params) => { return Formatters.DepartingVVCstringTypeValueFormatter(params); }, width: 100 },
                    { headerName: "VVC Arr", field: "ArrivingVVC", valueGetter: (params) => { return Formatters.ArrivingVVCstringTypeValueFormatter(params); }, width: 100 },
                    { headerName: "TRIP", field: "TripStatusCdAndDFlag", tooltipField: "TripNameAndStatus", cellRenderer: ReeferCellRenderer.TripstatusIndicator, width: 70 },
                    { headerName: "INV", field: "AssetState", width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetState"); }, cellRenderer: ReeferCellRenderer.AssetStateFormatter },

                ]
            },
            {
                headerName: 'Identification History',
                children: [
                    { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
                    { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                    { headerName: "Model", field: "OEMModel", valueGetter: (params) => { return ReeferFormatters.UnitTypesListFormatters(params, self.props.reeferFormatter.UnitTypesList); }, cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                ]
            },
            {
                headerName: "Booking History",
                children: [
                    { headerName: "Booking #", field: "BookingNumber", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "BK temp", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: ReeferFormatters.TemperatureFormatterForBooking, field: "TemperatureUnit", width: 130 },
                    { headerName: "CC profile", field: "CCProfileCode", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                    { headerName: "CC alerts", field: "CCAlarms", cellRenderer: ReeferCellRenderer.CCAlarmDescriptionFormatter, refData: self.props.reeferFormatter.AlarmMasterList, width: 150 },
                ]
            },
            {
                headerName: 'Event and Location History',
                children: [
                    {
                        headerName: "Event", field: "EventDescription", width: 150, valueGetter: (params) => {
                            return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList,
                                self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts);
                        }, cellRenderer: ReeferCellRenderer.StringTypeFormatter
                    },
                    { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Event notes", field: "EventNotes", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    {
                        headerName: "Door", field: "DoorOpen", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, getQuickFilterText: ReeferFormatters.doorQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return ReeferFormatters.doorFormatterFilter(params); } },
                        valueGetter: (params) => { return ReeferFormatters.DoorFormatterSorting(params); }, cellRenderer: ReeferFormatters.doorFormatter, width: 140
                    },
                    { headerName: "Door time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DoorEventDtm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDoorEventDtmForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DoorEventDtm"); }, cellRenderer: Formatters.dateTypeFormatter, width: 170 },
                    { headerName: "Device fence", field: "GeofenceName", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Server fence", field: "ServerGeofenceName", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Device fence ID", field: "Geofence", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "Server fence ID", field: "ServerGeofence", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Loc coords", field: "GPSCoords", valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, cellRenderer: ReeferCellRenderer.GPSCoordsFormatter, width: 150 },
                    { headerName: "Loc age (h:m:s)", field: "GPSLastLock", cellRenderer: Formatters.reeferSecondsToTimeConverterFilter, width: 150 },
                    { headerName: "City", field: "City", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                    { headerName: "State", field: "State", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                    { headerName: "Country", field: "Country", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Zip", field: "Zip", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 100 },
                    { headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "ModifiedDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                ]
            },
            {
                headerName: 'Reefer Datalog Events History',
                children: [
                    { headerName: "DL event", field: "DLEventMasterID", width: 150, valueGetter: (params) => { return ReeferFormatters.DLEventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList); }, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
                    { headerName: "DL event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DLEventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Data 1", field: "DLParam1", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 110 },
                    { headerName: "Data 2", field: "DLParam2", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 110 },
                    { headerName: "Data 3", field: "DLParam3", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 110 },
                    { headerName: "Data 4", field: "DLParam4", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 110 },
                    { headerName: "Data 5", field: "DLParam5", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 110 }
                ]
            },
            {
                headerName: 'Reefer Status History',
                children: [
                    //{ headerName: "Region Fence ID", field: "RegionGeofence", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmDescriptionFormatter, refData: self.props.reeferFormatter.AlarmMasterList, width: 150 },
                    { headerName: "Opr mode", field: "RunningMode", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Reefer data", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "UnitEventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "T set", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "SetPoint", width: 90 },
                    { headerName: "T sup 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "SupplyTemp1", width: 90 },
                    { headerName: "T sup 2 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "SupplyTemp2", width: 90 },
                    { headerName: "T rtn 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "ReturnTemp1", width: 90 },
                    { headerName: "T rtn 2 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "ReturnTemp2", width: 90 },
                    { headerName: "T amb", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "AmbientTemp", width: 90 },
                    { headerName: "RH set", field: "HumiditySetpoint", cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
                    { headerName: "RH read", field: "Humidity", cellRenderer: ReeferFormatters.HumiditySettingFormatter, width: 90 },
                    { headerName: "CO2 set", field: "CO2Setpoint", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "CO2 read", field: "CO2Reading", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "O2 set", field: "O2Setpoint", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "O2 read", field: "O2Reading", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "T evap in ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "EvaporatorInletSensor", width: 110 },
                    { headerName: "T evap out ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "EvaporatorOutletSensor", width: 110 },
                    { headerName: "P suc", field: "CompositeSuctionPressure", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "T suc", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "CompressorSuctionTemp", width: 90 },
                    { headerName: "P dis", field: "DischargePressure", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "T dis ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "CompressorDischargeTemp", width: 90 },
                    { headerName: "T dis 2 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "CompressorDischargeTemp2", width: 90 },
                    { headerName: "T econ in ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "EconomizerInTemp", width: 90, columnGroupShow: 'open' },
                    { headerName: "T econ out ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "EconomizerOutTemp", width: 90, columnGroupShow: 'open' },
                    { headerName: "P cond", field: "CondenserPressure", cellRenderer: ReeferFormatters.sensorDataPCondFormatter, width: 90 },
                    { headerName: "T cond wall ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "CondenserTemperature", width: 110 },
                    { headerName: "M cond", field: "CondenserFanOutPut", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Evap fan set", field: "EvaporatorFanSpeedControl", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140, columnGroupShow: 'open' },
                    { headerName: "LS evap", field: "LowSpeedEvaporatorFanOutPut", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "HS evap", field: "HighSpeedEvaporatorFanOutPut", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Air pump hr", field: "AirPumpRunHours", cellRenderer: ReeferFormatters.AirPumpRunHoursFormatter, width: 120, columnGroupShow: 'open' },
                    { headerName: "Heat on", field: "HeaterOnTime", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Open exp", field: "EvaporatorExpansionValveOpening", cellRenderer: ReeferFormatters.sensorDataOpenExpFormatter, width: 90 },
                    { headerName: "Open suc", field: "SuctionModulationValveOpening", cellRenderer: ReeferFormatters.sensorDataOpenSucFormatter, width: 90 },
                    { headerName: "Open dis", field: "HotGasValveOpening", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Open econ", field: "EconomizerValveOpening", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Comp freq", field: "CompressorFrequency", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Comp curr", field: "CompressorCurrent", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "Comp hr", field: "CompressorRunHours",  cellRenderer: ReeferFormatters.CompressorRunHoursFormatter, width: 120 },
                    { headerName: "CT state", field: "ColdTreatmentState", valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ColdTreatmentState"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, },
                    { headerName: "CT dur (d)", field: "CTDuration", valueGetter: (params) => { return Formatters.CTDurationSorting(params); }, cellRenderer: ReeferFormatters.CTDurationFormatter, width: 90, columnGroupShow: 'open', }, // RCNG-1818
                    { headerName: "CT max ", headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CTTempLimit"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CTTempLimit", width: 100, columnGroupShow: 'open', },//RCNG-1818
                    { headerName: "CT final ", headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CTPostSetPoint"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CTPostSetPoint", width: 100, columnGroupShow: 'open', },//RCNG-1818
                    { headerName: "CT rem (hr)", field: "CTRemainingTime", valueGetter: (params) => { return Formatters.CTRemainingTimeSorting(params); }, cellRenderer: ReeferFormatters.CTRemainingTimeFormatter, width: 120, columnGroupShow: 'open', }, // RCNG-1818
 
                    { headerName: "CT Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CTTime", cellRenderer: Formatters.dateTypeFormatter, width: 120 },

                    { headerName: "USDA 1", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "USDA1Temp", width: 90 },
                    { headerName: "USDA 2", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "USDA2Temp", width: 90 },
                    { headerName: "USDA 3", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "USDA3Temp", width: 90 },
                    { headerName: "USDA 4 cargo ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "Cargo4Temp", width: 130 },
                    { headerName: "Vent pos", field: "VentPositionSensorCMH", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "CA mode", field: "ControlledAtmosphereMode", cellRenderer: ReeferFormatters.ControlledAtmosphereMode, width: 150 },
                    { headerName: "Bulb mode", field: "BulbMode", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                    { headerName: "CA hr", field: "CARunHours", cellRenderer: ReeferFormatters.CARunHoursFormatter, width: 120, columnGroupShow: 'open' },
                    { headerName: "CA SW ver", field: "CASoftwareRevision", cellRenderer: ReeferFormatters.CASWVerFormatter, width: 120, columnGroupShow: 'open' },
                    { headerName: "3 ph curr", field: "ThreePhaseCurrent", cellRenderer: ReeferFormatters.Current3PhaseFormatter, width: 135 },
                    { headerName: "Tot curr", field: "TotalCurrentDraw", cellRenderer: Formatters.sensorDataFormatter, width: 100 },
                    { headerName: "L1 (VAC)", field: "LineVoltage1", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "L2 (VAC)", field: "LineVoltage2", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "L3 (VAC)", field: "LineVoltage3", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "EverFRESH", field: "EverFRESH", cellRenderer: ReeferFormatters.everFreshFormatter, width: 120 },
                    //EverFRESH missing
                    { headerName: "VFD", field: "VFD", cellRenderer: Formatters.sensorDataFormatter, width: 90 },
                    { headerName: "OEM PTI state", field: "TripWiseStatusDescription", valueGetter: (params) => { return ReeferFormatters.TripWiseStatusSorting(params, self.props.reeferFormatter.TripWiseStatusList); }, cellRenderer: (params) => { return ReeferCellRenderer.TripWiseStatusFormatter(params, self.props.reeferFormatter.TripWiseStatusList); }, width: 90 },
                    { headerName: "OEM PTI exp (d)", field: "TripWiseExpiration", valueGetter: (params) => { return Formatters.TripWiseExpirationSorting(params); }, cellRenderer: ReeferFormatters.TripWiseExpirationFormatter, width: 90 }, // RCNG-169
                    { headerName: "OEM PTI term start", field: "DimiStartAfter", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DimiStartAfter"); }, cellRenderer: ReeferCellRenderer.OEMPTITypeFormatter },
                    { headerName: "OEM PTI term (d)", field: "DimiTerm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DimiTermSorting(params); }, cellRenderer: ReeferFormatters.DimiRemainTermFormatter, width: 130 },
                    { headerName: "OEM PTI term rem (d)", field: "DimiRemainTerm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DimiRemainTermSorting(params); }, cellRenderer: ReeferFormatters.DimiRemainTermFormatter, width: 130 },
                    
                    { headerName: "PTI state", field: "PTIState", valueGetter: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.props.reeferFormatter.PreTripList); }, cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "PTI result", field: "PTResult", tooltip: Formatters.toolTipFormatter, valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); }, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 130 },
                    { headerName: "PTI Type", field: "PTIType", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 120 },
                    { headerName: "PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Freq", field: "LineFrequency", cellRenderer: ReeferFormatters.lineFrequencyFormatter, width: 130 },
                    { headerName: "Const s/n", field: "ControllerSerialNumber", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Cont time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DataLoggerDtm", cellRenderer: Formatters.dateTypeFormatter, width: 120 },
                    { headerName: "Cont SW version", field: "SoftwareRevision", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 120 },
                    { headerName: "Cont Set", field: "ControllerTypeSetting", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 90 },
                    { headerName: "Fresh air type", field: "FreshAirType", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 120 },
                    { headerName: "Defrost int", field: "DefrostInterval", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130, columnGroupShow: 'open' },
                    { headerName: "Tot pwr kWh", field: "PowerMeter", cellRenderer: ReeferFormatters.PowerMeterFormatter, width: 130 },
                ]
            },
            {
                headerName: 'Device Status History',
                children: [
                    { headerName: "Device ID", field: "RCDID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Device supply (V)", field: "ReeferACPowerLevel", cellRenderer: Formatters.sensorDataFormatter, width: 120 },
                    //{ headerName: "Device pwr source", field: "RCDPowerSourceCd", cellRenderer: Formatters.rcdPowerSourceFormatter, width: 120 },                

                    { headerName: "Device FW ver", field: "RCDFirmwareVersion", valueGetter: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "Device BL ver", field: "RCDBootloaderVersion", valueGetter: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "Device mesh FW ver", field: "RCDMeshFirmwareVersion", valueGetter: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.props.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "Device temp ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "DeviceTemp", width: 130 },
                    { headerName: "Device bat (V)", field: "BatteryVoltage", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    {
                        headerName: "Door bat (V)", field: "DoorSensorBatteryVoltage",
                        valueGetter: (params) => { return Formatters.DoorBattVoltageSortingFieldName(params, "DoorSensorBatteryVoltage"); },
                        filterParams: { valueGetter: params => { return Formatters.DoorBatteryVoltageFormatterForFilter(params); } },
                        cellRenderer: Formatters.BattVoltageValueFormatter, width: 130
                    },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "Geofence revision", field: "RevisionNum", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "MSISDN", field: "MSISDN", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                    { headerName: "IMSI", field: "SIM_IMSI", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "ICCID", field: "ICCID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "EUI", field: "EUI", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "MCC (country)", field: "CountryName", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
                    { headerName: "MNC", field: "MNC", cellRenderer: ReeferCellRenderer.MNCTypeFormatter, width: 70 },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 70 },
                    { headerName: "Tower ID", field: "TowerBaseStationID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
                    { headerName: "Cell gen", field: "CellNetGeneration", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 80 },
                    { headerName: "Cell signal", field: "RSSI", cellRenderer: ReeferCellRenderer.RSSITypeFormatter, width: 80 },

                    //{ headerName: "RFR COMMS.", field: "RCDRfrComErr", cellRenderer: Formatters.reeferCommsFormatter, width: 130 },
                ]
                //},
                //{
                //    headerName: 'Device Sensor',
                //    children: [
                //        { headerName: "Temp Sup. 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SensorSupplyTemp1", width: 120 },
                //        { headerName: "Temp Rtn. 1 ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SensorReturnTemp1", width: 120 }
                //    ]
            }
        ];
    }

    updateReeferMapDimensions() {
        $("#reeferMapGrid-height").css('min-height', $(window).height() - 400);
        $("#reeferMapGrid-height").css('max-height', $(window).height() - 400);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateReeferMapDimensions.bind(this));
    }

    radioButtonChange(value) {
        if (value == "ReeferTrace") {
            this.populateSelectedReefersDates();
            this.bindReeferHistoryData();
            document.getElementById("CurrentLocation").classList.remove("active");
            document.getElementById("ReeferTrace").classList.add("active");
            this.setState({ mapState: value });
        }
        else {
            this.populateDefaultDates();
            this.bindReeferCurrentData();
            document.getElementById("ReeferTrace").classList.remove("active");
            document.getElementById("CurrentLocation").classList.add("active");
            this.setState({ mapState: value });
        }
    }

    ShowFullMap() {
        $("#Container1").hide();
        $("#Container2").hide();
        $("#Container3").hide();
        $("#reeferMapGrid-height").css('min-height', $(window).height() - 102);
        $("#reeferMapGrid-height").css('max-height', $(window).height() - 102);
        $("#reeferMapGrid-height").css("border", "none");
        $("#dvFullScreen").css("display", "none");
        $("#dvResizeScreen").css("display", "block");
        $('.ReeferMapCallout').addClass('m-2');
    }

    MinimizeMap() {
        $("#Container1").show();
        $("#Container2").show();
        $("#Container3").show();
        $("#reeferMapGrid-height").css('min-height', $(window).height() - 400); 
        $("#reeferMapGrid-height").css('max-height', $(window).height() - 400);
        $("#reeferMapGrid-height").css("border", "1px solid #045976");
        $("#dvFullScreen").css("display", "block");
        $("#dvResizeScreen").css("display", "none");
        $('.ReeferMapCallout').removeClass('m-2');
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    downloadPTReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([self.state.PTIReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'PT_' + self.state.ReportReeferId + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(self.state.PTReport));
            element.setAttribute('download', 'PT_' + self.state.ReportReeferId + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    printPTReport() {
        var divToPrint = document.getElementById("printData");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }

    navigateToNextCell(params: any) {
        var previousCell = params.previousCellDef;
        var suggestedNextCell = params.nextCellDef;

        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;

        switch (params.key) {
            case KEY_DOWN:
                previousCell = params.previousCellDef;
                // set selected cell on current cell + 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex + 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_UP:
                previousCell = params.previousCellDef;
                // set selected cell on current cell - 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex - 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_LEFT:
            case KEY_RIGHT:
                return suggestedNextCell;
            default:
                throw "this will never happen, navigation is always on of the 4 keys above";
        }
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function(item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function() {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "ReeferMapGrid");
            },
        });
        return finalMenuItem;
    }
    
    validateRevisionNum(dashboardPreferenceId: any) {
        var confirmationMessage = "Your changes cannot be saved because this Dashboard has been modified by another user. Either the latest version of this Dashboard can be reloaded now (and changes can be reapplied) or your changes and any subsequent changes you make can be applied temporarily (without saving) until the Dashboard is reloaded. Reload now?"
        RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, self.refreshRevisionNumConfirm.bind(this, dashboardPreferenceId), self.closeRevisionConfirmation.bind(this));
    }
    
    refreshRevisionNumConfirm(dashboardPreferenceId: any) {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
                if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
                {                    
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    this.setState({ RevisionNum: defaultPreferenceName[0].RevisionNum  });
                }            
                $('#globalLoader').hide();   
            });
    }

    refreshRevisionNum(dashboardPreferenceId: any) {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(result => {
                var data: any = result;
                if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
                {                    
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    this.setState({ RevisionNum: defaultPreferenceName[0].RevisionNum  });
                }            
            });
    }
    closeRevisionConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    public render() {
        return <div>
            <div className='page-controls-container' id="Container1">
                <div className='row'>
                    <div className='col-lg-7'>

                        <div className="btn-group btn-group-dsd" role="group" aria-label="Basic radio toggle button group">
                            <input type="radio" className="btn-check" value="CurrentLocation" name="GroupType" checked={this.state.mapState == 'CurrentLocation'} />
                            <label id="CurrentLocation" className="btn btn-outline-secondary" onClick={(e) => this.radioButtonChange('CurrentLocation')}> Current Location </label>

                            <input type="radio" className="btn-check" value="ReeferTrace" name="GroupType" checked={this.state.mapState == 'ReeferTrace'} />
                            <label id="ReeferTrace" className="btn btn-outline-secondary" onClick={(e) => this.radioButtonChange('ReeferTrace')}> Reefer Trace </label>

                        </div>

                    </div>
                    <div className='col-lg-5'>

                        <div className="input-group from-to-calender">
                            <span className="input-group-text">From</span>
                           
                                <DatePicker
                                    selected={new Date(this.state.Filters.FromDate)}
                                    maxDate={new Date(this.state.PreferenceDTTM)}
                                    onChange={this.FromDateChange.bind(this)}
                                    timeInputLabel="Time:"
                                    showYearDropdown
                                    yearDropdownItemNumber={5}
                                    dateFormat="MM/dd/yyyy hh:mm aa"
                                    showTimeInput  
                                    className=""
                                    id="dtFromDate"
                                />
                          
                            <span className="input-group-text">To</span>
                         
                                <DatePicker
                                    selected={new Date(this.state.Filters.ToDate)}
                                    maxDate={new Date(this.state.PreferenceDTTM)}
                                    onChange={this.ToDateChange.bind(this)}
                                    timeInputLabel="Time:"
                                    showYearDropdown
                                    yearDropdownItemNumber={5}
                                    dateFormat="MM/dd/yyyy hh:mm aa"
                                    showTimeInput
                                    className=""
                                    id='dtToDate'
                                />
                           

                            {
                                this.state.mapState == 'CurrentLocation' ?
                                    <button type='button' disabled={this.state.mapState == 'CurrentLocation'} className='btn btn-primary float-end'>Search</button>
                                    :
                                    <button type='button' disabled={this.state.mapState == 'CurrentLocation'} onClick={this.ApplyReeferHistorySearch.bind(this)} className='btn btn-primary float-end'>Search</button>
                            }

                        </div>

                    </div>
                 
                </div>
            </div>
            <div id="Container3">
                {
                    this.state.mapState == 'CurrentLocation' ?
                        <GridToolBarExcel refreshGrid={this.refreshGrid.bind(this)}
                            gridData={this.state.rowData}
                            gridApiParams={this.state.gridApiParams}
                            colDefs={this.state.columnDefs}
                            colDefs2={columnDefs2}
                            parentchild={"C"}
                            formName={"ReeferMapGrid"}
                            functionId={"42"}
                            sensorData={reeferAssetSensors}
                            isHistory={"False"}
                            widgetId={5} 
                            dashboardPreferenceId = {this.state.DashboardPreferenceId}
                            isReadOnly={this.state.IsReadOnly}
                            revisionNum={this.state.RevisionNum}
                            validateRevisionNum={this.validateRevisionNum.bind(this)}
                            refreshRevisionNum={this.refreshRevisionNum.bind(this)}
                            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}/>
                        :
                        <GridToolBarExcel refreshGrid={this.refreshGrid.bind(this)}
                            gridData={this.state.rowData}
                            gridApiParams={this.state.gridApiParams}
                            colDefs={this.state.columnDefs}
                            colDefs2={columnDefs2}
                            parentchild={"C"}
                            formName={"ReeferMapGrid"}
                            functionId={"42"}
                            sensorData={reeferAssetSensors}
                            isHistory={"True"}
                            widgetId={5} 
                            dashboardPreferenceId = {this.state.DashboardPreferenceId}
                            isReadOnly={this.state.IsReadOnly}
                            revisionNum={this.state.RevisionNum}
                            validateRevisionNum={this.validateRevisionNum.bind(this)}
                            refreshRevisionNum={this.refreshRevisionNum.bind(this)}
                            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}/>
                   }
            </div>
            <div className='row' id="Container2">
                <div className='col-lg-12'>
                    <div className="ag-theme-fresh reeferMapGrid-height">
                        <AgGridReact
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            onGridReady={this.onGridReady}
                            pagination={true}
                            rowSelection={'single'}
                            accentedSort={true}
                            onSelectionChanged={this.onGridSelectionChanged}
                            onPaginationChanged={this.onPaginationPageLoaded}
                            paginationPageSize={this.state.pageSize}
                            navigateToNextCell={this.navigateToNextCell}
                            getMainMenuItems={this.getMainMenuItems.bind(this)}
                            onDragStopped={this.onSavecolumnorder.bind(this)}
                            overlayLoadingTemplate={this.state.overlayLoadingTemplate}>
                        </AgGridReact>
                    </div>
                    <div className='pageSize'>
                        <span className='pageSize-lable'>Page Size:</span>
                        <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className='row' id="Container3">
                <div className='col-lg-12 position-relative'>
                    <div id="dvFullScreen" onClick={this.ShowFullMap.bind(this)} className='map-full-screen'>
                        <span className='fa-solid fa-expand'></span>
                    </div>
                    <div id="dvResizeScreen" onClick={this.MinimizeMap.bind(this)} className='map-half-screen'>
                        <span className='fa-regular fa-compress'></span>
                    </div>
                    <div id='reeferMapGrid-height' className='ReeferMapCallout'></div>
                    {this.state.IsLocationEstimated == true ? <div className='ReeferMapGridEstimated'>Location estimated</div> : ''}
                </div>
            </div>
            <div className="modal fade" id="contextMenuModelReport" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" id="contextMenuModelHeader">
                            <h5 className="modal-title">Pre-Trip Report</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                           
                        </div>
                        <div className="modal-body ptr-report pb-3">
                            <div className='aggrid-icons-bg'>
                                <div className="btn-group aggrid-icons">
                                    <button type="button" id="hidePopUpBtn" title='Download' className="btn btn-outline-secondary" onClick={this.downloadPTReport.bind(this)} ><span className='fa fa-download'></span></button>
                                    <button type="button" id="hidePopUpBtn" title='Print' className="btn btn-outline-secondary" onClick={this.printPTReport.bind(this)}><span className='fa fa-print'></span></button>
                                </div>
                            </div>
                            {this.state.popUpHtmlReport}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTrigger" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModelReport" />
            <div className='hidden' id="printData"><div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} /></div>
        </div>;
    }

    public componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsForReefers('2');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            MapCallout.InitializeMap("reeferMapGrid-height");
            this.updateReeferMapDimensions();
            window.addEventListener("resize", this.updateReeferMapDimensions.bind(this));
           
           
            document.getElementById("CurrentLocation").classList.add("active");
            document.getElementById("ReeferTrace").classList.remove("active");
            
            $("#dvResizeScreen").css("display", "none");

            setTimeout(() => { this.loadTraceMapPushpins(); }, 500);
            Excel.draggableModalPopup(document.getElementById("contextMenuModelReport"));
        }
    }

    loadTraceMapPushpins() {
        MapCallout.BindTraceMapPushpins(reeferCurrentStatus[0], "current", self.props.reeferFormatter);
    }

    public componentDidUpdate() {
        if (this.state.mapState == 'CurrentLocation') {
            $('#dtFromDate *').attr('disabled', 'disabled');      
            $('#dtToDate *').attr('disabled', 'disabled');
            $('#dtFromDate').css('pointer-events', 'none');
            $('#dtToDate').css('pointer-events', 'none');
        }
        else {
            $('#dtFromDate *').removeAttr('disabled');
            $('#dtToDate *').removeAttr('disabled');
            $('#dtFromDate').css('pointer-events', 'auto');
            $('#dtToDate').css('pointer-events', 'auto');
        }
    }
}

class ReeferHistoryFilter {
    FromDate: string;
    ToDate: string;
    Units: string;
}

interface ReeferMasterStatus {
    UnitRCDAssociationHistoryID: number,
    LastParentEventID: number,
    ParentEventID: number,
    UnitMasterID: number,
    UnitPrefix: string,
    UnitNumber: string,
    ReeferID: string,
    UnitEventID: number,
    AlarmsList: string,
    CCAlarms: string,
    CCSeverityLevel: string,
    MicroAlarms: string,
    MASeverityLevel: string,
    UnitUSDAHistoryID: number,
    USDA1Temp: number,
    USDA2Temp: number,
    USDA3Temp: number,
    Cargo4Temp: number,
    O2Setpoint: number,
    CO2Setpoint: number,
    RunningMode: string,
    URH_UnitReadingsHistoryID: number,
    Humidity: number,
    UnitTypeCd: string,
    AmbientTemp: number,
    CompressorSuctionTemp: number,
    CompressorDischargeTemp: number,
    ReturnTemp1: number,
    SupplyTemp1: number,
    SupplyTemp2: number,
    ReturnTemp2: number,
    EvaporatorTemp: number,
    NumberOfAlarmsInQue: number,
    DischargePressure: number,
    CompositeSuctionPressure: number,
    VentPositionSensorCMH: number,
    PretripTestStateID: any,
    SetPoint: number,
    O2Reading: number,
    CO2Reading: number,
    TotalCurrentDraw: number,
    LowSpeedEvaporatorFanOutPut: string,
    HighSpeedEvaporatorFanOutPut: string,
    CondenserFanOutPut: string,
    HumiditySetpoint: number,
    SoftwareRevision: string,
    ControllerSerialNumber: string,
    CompressorFrequency: number,
    CondenserTemperature: number,
    CondenserPressure: number,
    HeaterOnTime: number,
    EvaporatorExpansionValveOpening: number,
    LineFrequency: number,
    DataLoggerDtm: string,
    TimeToDefrost: number,
    CurrentPhaseA: number,
    CurrentPhaseB: number,
    CurrentPhaseC: number,
    ThreePhaseCurrent: string,
    ReturnTempLongAvg: number,
    AmbientTempLongAvg: number,
    CompositeSuctionPressureLongAvg: number,
    DischargePressureLongAvg: number,
    SupplyTemperatureLongAvg: number,
    ReturnTemperatureLongAvg: number,
    CompressorSuctionTempLongAvg: number,
    CompressorCondensorTempLongAvg: number,
    RCDEventID: number,
    R_EventMasterID: number,
    R_ParentEventID: number,
    RCDMasterID: number,
    RCDMasterHistoryID: number,
    RCDGSMPositionHistoryID: number,
    RCDLocationHistoryID: number,
    RCDGPSPositionHistoryID: number,
    RCDStateReportedHistoryID: number,
    RCDAlarmSummaryHistoryID: number,
    R_EventDTTM: string,
    RunState: number,
    R_RCDStateReportedHistoryID: number,
    IsAcceptableACVoltage: boolean,
    IsAcceptableBatteryVoltage: boolean,
    BatteryVoltage: number,
    RCDPowerSourceCd: string,
    ReeferACPowerLevel: number,
    ReeferOEMTypeCd: string,
    LineVoltage1: number,
    LineVoltage2: number,
    LineVoltage3: number,
    DeviceTemp: number,
    LastUnitEventID: number,
    EventMasterID: number,
    EventDTTM: any,
    ModifiedDTTM: any,
    U_UnitAlarmSummaryHistoryID: number,
    UnitControlEventID: number,
    C_EventDTTM: any,
    C_EventMasterID: number,
    C_ParentEventID: number,
    UnitVesselOperationsID: any,
    UnitCargoCareID: any,
    C_UnitAlarmSummaryHistoryID: any,
    Status: any,
    IsOnVessel: any,
    IsCargoCare: any,
    C_ModifiedDTTM: any,
    GeofenceName: string,
    RCDID: string,
    RCDFirmwareVersion: string,
    RCDBootloaderVersion: string,
    RCDMeshFirmwareVersion: string,
    RevisionNum: number,
    GPSLatitude: number,
    GPSLongitude: number,
    GPSLastLock: number,
    GPSCoords: string
    GPSLockState: string,
    IsInsideGeofence: boolean,
    Geofence: string,
    ServerGeofence: string;
    RegionGeofence: string;
    ActiveCommands: boolean,
    PendingCommands: boolean,
    ErrorCommands: boolean,
    CustomerAccessGroupIDList: string,
    TowerBaseStationID: number,
    TowerLocalizationAreaCode: number,
    MNC: number,
    SuctionModulationValveOpening: number,
    HotGasValveOpening: number,
    EconomizerValveOpening: number,
    RSSI: number,
    MSISDN: string,
    SIM_IMSI: string,
    ICCID: string,
    CompressorEvaporatorTempLongAvg: number,
    CompressorDischargeTempLongAvg: number,
    CountryCd: string,
    CountryName: string,
    UnitEventDTTM: any,
    PowerProfileCd: string,
    NotReportingFlag: number,
    PowerStateIsActive: boolean,
    PtiRunning: boolean,
    ControllerSerialNumberChgFlag: boolean,
    IsActiveAssociation: boolean,
    IsReeferCommunicationEstablished: boolean,
    UnitSettingsHistoryID: number,
    RCDReportingInterval: number,
    ReeferConfigTypeCd: string,
    Street: string,
    City: string,
    State: string,
    Zip: string,
    CustomerID: number,
    CustomerName: string,
    RCDRfrComErr: boolean,
    VesselID: string,
    VoyageID: string,
    PortOfDestination: string,
    PortOfDeparture: string,
    TripId: number,
    TripStatusCd: string,
    TripStatusCdAndDFlag: string,
    DeviationFlg: boolean,
    TripDefStatusDsc: string,
    TripNameAndStatus: string,
    TripRouteWaypointId: number,
    BookedTemperature: number,
    BookingNumber: string,
    TemperatureUnit: string,
    CommentExists: number;
    DLParam1: string;
    DLParam2: string;
    DLParam3: string;
    DLParam4: string;
    DLParam5: string;
    CellNetGeneration: string;
    DLEventMasterID?: number;
    DLEventDTTM?: Date;
    CargoCareCustomerProfileID?: number,
    CCProfileCode: string,
    ColdTreatmentState: string,
    EvaporatorInletSensor: any;
    EvaporatorOutletSensor: any;
	CompressorDischargeTemp2: any;
    AirPumpRunHours: any;
	CARunHours: any;
	CASoftwareRevision: any;
	EconomizerInTemp: any;
	EconomizerOutTemp: any;
	CompressorRunHours: any;
	PowerMeter: any;								
	LineFrequencyQualifier: any;
	DefrostInterval: any;
	DefrostIntervalQualifier: any;
	PTIType: any;
    ControllerTypeCd: any;
    CompressorCurrent: any;
    BulbMode: any;
    EvaporatorFanSpeedControl: any;
    CTTime?: Date;
    ReeferBatteryPct: number;
}
